import Popconfirm from './_popconfirm';
export default Popconfirm;
